<template>
  <div class="box">
    <ModalUser
      v-if="modalClick"
      ref="companyModal"
      @CloseModal="modalClick = !modalClick"
    />
    <div class="box-header">
      <h3 class="box-title">User List</h3>
      <span class="icon" @click="modalClick = true"
        ><i class="fad fa-plus-square"></i
      ></span>
    </div>
    <table class="table" id="my-table">
      <thead>
        <tr>
          <th>First Name</th>
          <th>Login Email</th>
          <th class="is-sm">Role</th>
          <th class="text-right">Option</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(i, index) in staff" :key="index">
          <td>{{ i.name }}</td>
          <td>{{ i.email }}</td>
          <td>{{ i.role }}</td>
          <td>
            <div class="buttons">
              <button class="button is-small" @click="reset(i.email)">
                <i class="fa-regular fa-arrows-rotate"></i>
                <span>Reset Password</span>
              </button>
              <button
                class="button is-small"
                @click="openUpdatemodal(i.UserId)"
              >
                <i class="fas fa-expand"></i><span>View</span>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import ModalUser from "@coms/company-setup/addUser";
import { GET_STAFF, RESET } from "@/graphql/employer/employer";
import { apolloClient } from "./../../services/apollo-client";
export default {
  components: {
    ModalUser,
  },
  data: () => ({
    modalClick: false,
    staff: [],
  }),
  created() {
    this.queryStaff();
  },
  methods: {
    async openUpdatemodal(id) {
      this.modalClick = true;

      this.$nextTick(() => {
        this.$refs.companyModal.userId = id;
      }, 1000);
    },
    async queryStaff() {
      const res = await apolloClient.query({
        query: GET_STAFF,
        variables: {
          UserId: this.$route.params.UserId,
        },
      });
      this.staff = res.data.getStaff;
    },
    async reset(email) {
      const res = await apolloClient.mutate({
        mutation: RESET,
        variables: {
          email: email,
        },
      });
      const isConfirmed = await this.$dialog.alert("Complete");
      if (!isConfirmed) return;
    },
  },
};
</script>

<style lang="scss" scoped>
.buttons {
  display: flex;
  justify-content: flex-end;
  button {
    &:nth-child(1) {
      background-color: rgba(var(--alert-color-rgb), 0.095);
      color: var(--alert-color);
      border-color: var(--alert-color);
    }
    &:nth-child(2) {
      background-color: rgba(var(--primary-color-rgb), 0.095);
      color: var(--primary-color);
      border-color: var(--primary-color);
    }
  }
}
.box-header {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  .box-title {
    font-size: 18px;
    font-weight: 700;
    margin: 0;
  }
  .icon {
    margin-left: 10px;
    cursor: pointer;
    font-size: 24px;
    color: var(--primary-color);
    i {
      font-weight: 700;
    }
  }
}
</style>
